import type { TOC } from '@ember/component/template-only';

// While a child route (edit, clean-up, details) loads, this renders in the Metrics page's outlet.
// Without it Ember falls back to `metrics-loading`, which replaces the page and remounts it.
const MetricsChildLoadingRouteTemplate: TOC<object> = <template></template>;

export default MetricsChildLoadingRouteTemplate;
